import React, { useState } from 'react';
import '../styles/faq.css';
import { useTranslation } from 'react-i18next';

const FaqComponent = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const { t } = useTranslation('home');

  const faqs = [
    {
      question: 'faq-question-1',
      answer: 'faq-answer-1'
    },
    {
      question: 'faq-question-2',
      answer: 'faq-answer-2'
    },
    {
      question: 'faq-question-3',
      answer: 'faq-answer-3'
    },
    {
      question: 'faq-question-4',
      answer: 'faq-answer-4'
    },
    {
      question: 'faq-question-5',
      answer: 'faq-answer-5'
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container col-md-9 col-sm-12">
      <h2>{t('faq-title')}</h2>
      {faqs.map((faq, index) => (
        <div className={`faq-item ${activeIndex === index ? 'active' : ''}`} key={index}>
          <button className="faq-question" onClick={() => toggleFAQ(index)}>
            {t(faq.question)}
          </button>
          <div className="faq-answer" style={{ display: activeIndex === index ? 'block' : 'none' }}>
            {t(faq.answer).split('\n').map((paragraph, i) => (
              <p key={i}>{t(paragraph)}</p>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FaqComponent;
